import fetch from '@/utils/fetch';
import { message } from 'antd';
import filterNull from '@/utils/filterNull';

const model = {
  state: {
    queryParams: {
      per_page: 10,
      cur_page: 1,
    },
    list: [],
    listTotal: 0,
    listLoading: false,
    bussinessList: [],
    addressList: [],
    // 筛选项数据
    filterInfo: {
      addressType: -1, // -1 全部
      takeMealCode: '',
    },
    groupDetail: {}, // businessDistrictId, businessDistrictName
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { OperationPickMeal }, getState }) => ({
    async getList() {
      const { queryParams } = getState().OperationPickMeal;
      const { cur_page, per_page, ...newParams } = queryParams;
      OperationPickMeal.setState({ listLoading: true });
      const data = await fetch('/saasmerchant/web/mealgroup/grouplist', {
        type: 'POST',
        params: filterNull({
          page: cur_page,
          pageSize: per_page,
          ...newParams,
          groupId: queryParams.groupId ? Number(queryParams.groupId) : undefined,
        }),
        useJson: true,
      });
      OperationPickMeal.setState({ listLoading: false });
      if (data) {
        OperationPickMeal.setState({ list: data.list, listTotal: data.total });
      }
    },
    onSearch(queryParams) {
      OperationPickMeal.setState({ queryParams });
      OperationPickMeal.getList();
    },
    onNav(page) {
      const { queryParams } = getState().OperationPickMeal;
      OperationPickMeal.setState({ queryParams: { ...queryParams, cur_page: page } });
      OperationPickMeal.getList();
    },
    async getBussinessList(params) {
      const { groupDetail } = getState().OperationPickMeal;
      const data = await fetch('/saasmerchant/fsarea/businessDistrict/queryCbdList', {
        params: {
          businessDistrictName: params && params.businessDistrictName,
          cbdStatus: 1, // 生效
        },
      });
      if (data) {
        OperationPickMeal.setState({
          bussinessList: data,
          groupDetail: {
            ...groupDetail,
            businessDistrictName: params && params.businessDistrictName,
            businessDistrictId: params && params.businessDistrictId,
          },
        });
      }
      return data;
    },
    async setBusinessDistrictId(businessDistrictId) {
      const { groupDetail } = getState().OperationPickMeal;
      const data = await OperationPickMeal.getBussinessList({ businessDistrictId });
      if (data && data.list) {
        OperationPickMeal.setState({
          groupDetail: {
            ...groupDetail,
            businessDistrictName: data.list[0].businessDistrictName,
            businessDistrictId,
          },
        });
      }
      OperationPickMeal.getAddressList();
    },
    async getAddressList() {
      const { businessDistrictId } = getState().OperationPickMeal.groupDetail;
      const { filterInfo } = getState().OperationPickMeal;
      if (!businessDistrictId) {
        message.error('请先选择商圈！');
        return;
      }
      const data = await fetch(
        '/saasmerchant/fsarea/businessDistrict/searchBusinessDistrictCompany',
        {
          params: {
            businessDistrictId,
            status: 1,
            ...filterInfo,
          },
        },
      );
      if (data && data.companyList) {
        OperationPickMeal.setState({
          addressList: data.companyList,
        });
      }
    },

    // 设置筛选项
    setFilferInfo(params) {
      const { filterInfo } = getState().OperationPickMeal;
      OperationPickMeal.setState({ filterInfo: { ...filterInfo, ...params } });
    },
    setGroupDetail(params) {
      OperationPickMeal.setState({ groupDetail: { ...params } });
    },
    // 新增或修改取餐组
    async savePickMealGroup(params) {
      const { groupName, addrList, groupId } = params;
      const { businessDistrictId } = getState().OperationPickMeal.groupDetail;
      const data = await fetch('/saasmerchant/web/mealgroup/savegroup', {
        type: 'POST',
        useJson: true,
        params: {
          groupId: groupId ? Number(groupId) : undefined,
          groupName,
          addrList,
          businessDistrictId: Number(businessDistrictId),
        },
      });
      if (data) {
        OperationPickMeal.setBussinessAddress();
      }
      return data;
    },
    setBussinessAddress() {
      OperationPickMeal.setState({ addressList: [], bussinessList: [] });
    },
    // 获取取餐组信息
    async getPickMealGroupDetail(groupId) {
      const data = await fetch('/saasmerchant/web/mealgroup/groupdetail', {
        params: {
          groupId,
        },
      });
      if (data && data.list) {
        OperationPickMeal.setState({ groupDetail: data.list[0] });
        return data.list[0];
      }
      return data;
    },
    async changeGroupStatus(params) {
      const { groupId, status } = params;
      const data = await fetch('/saasmerchant/web/mealgroup/changegroup', {
        type: 'POST',
        useJson: true,
        params: {
          groupId,
          status: Number(!status),
        },
      });
      if (data) {
        message.success('切换状态成功！');
        OperationPickMeal.getList();
      }
    },
  }),
};
export default model;
